<template>
  <ShippingRates />
  <DeliveryEstimator v-if="isEDDEnabled" />
  <ul class="shipping__list">
    <li v-for="item in listItems" :key="item" class="shipping__list__item">
      {{ item }}
    </li>
  </ul>
</template>

<script>
import DeliveryEstimator from "@/components/product-display/DeliveryEstimatorV2.vue";
import ShippingRates from "@/components/product-display/ShippingRates.vue";

import { mapState, mapGetters } from "vuex";
import { regionFeatureToggles } from "@/config.js";

export default {
  name: "ShippingAndReturns",
  components: {
    ShippingRates,
    DeliveryEstimator,
  },
  props: {
    listItems: {
      type: Array,
      default: () => [
        "Return items within 30 days of receipt",
        "Use our returns label or your own courier",
        "Return costs covered by the customer",
        "Level 4 members are exempt from return costs",
      ],
    },
  },
  computed: {
    ...mapState("product", ["product"]),
    ...mapGetters("app", ["currencyCode"]),
    isEDDEnabled() {
      if (this.currencyCode) {
        return regionFeatureToggles[this.currencyCode].eddEnabled || false;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.shipping__list {
  @include utility-body(15px);
  color: $color-black;
  margin-left: 4px;

  &__item {
    list-style-type: disc;
    margin-left: 16px;
  }
}
</style>
